/* unplugin-vue-components disabled */import { render } from "./RechargeAgreement.vue?vue&type=template&id=f8387b02&scoped=true"
import script from "./RechargeAgreement.vue?vue&type=script&lang=js"
export * from "./RechargeAgreement.vue?vue&type=script&lang=js"

import "./RechargeAgreement.vue?vue&type=style&index=0&id=f8387b02&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8387b02"]])

export default __exports__